(() => {
  'use strict';

  const addOnType = 'DCP Extra Piece';
  let checkoutBypass = false;
  let validationPromise = null;
  let mutationTimer = 0;

  function properties(line) {
    return line && line.properties && typeof line.properties === 'object' ? line.properties : {};
  }

  function isSurcharge(line) {
    return String(properties(line)['_SRD Designer Add-On'] || '') === addOnType;
  }

  function isDcpBase(line) {
    const props = properties(line);
    return !isSurcharge(line) &&
      (String(props['Product Family'] || '') === 'Blank Canvas' ||
        String(props['Product Family'] || '') === 'Custom Die-Cut Vinyl Lettering' ||
        String(props['_Template Key'] || '') === 'blank_canvas');
  }

  function cents(value) {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : NaN;
  }

  function lineTotal(line) {
    return cents(line && (
      line.final_line_price !== undefined ? line.final_line_price : line.line_price
    ));
  }

  function validateCart(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    const managedLines = items.filter((line) => isDcpBase(line) || isSurcharge(line));
    if (!managedLines.length) return { managed: false, valid: true, errors: [] };

    const groups = new Map();
    const errors = [];
    managedLines.forEach((line) => {
      const group = String(properties(line)._dcp_pricing_group || '');
      if (!group) {
        errors.push(isSurcharge(line)
          ? 'An orphaned DCP additional-piece charge has no design pairing identity.'
          : 'A DCP design is missing its cart pairing identity.');
        return;
      }
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(line);
    });

    groups.forEach((lines) => {
      const bases = lines.filter(isDcpBase);
      const surcharges = lines.filter(isSurcharge);
      if (bases.length !== 1) {
        errors.push('A DCP design does not contain exactly one package line.');
        return;
      }

      const base = bases[0];
      const props = properties(base);
      if (String(props['_Blank Canvas Subfamily Key'] || '') === 'die_cutting') {
        const quantity = cents(props['_DCP Finished Quantity']);
        const unitPrice = cents(props['_DCP Unit Price Cents']);
        const expectedFinished = cents(props['_DCP Finished Price Cents']);
        const baseTotal = lineTotal(base);
        if (surcharges.length) errors.push('A Custom Die design contains an invalid Print surcharge line.');
        if (!Number.isFinite(quantity) || quantity < 1 || Number(base.quantity || 0) !== quantity) {
          errors.push('A Custom Die quantity was changed outside Edit Design.');
        }
        if (!Number.isFinite(unitPrice) || !Number.isFinite(expectedFinished)
            || expectedFinished !== unitPrice * quantity || baseTotal !== expectedFinished) {
          errors.push('A Custom Die price does not match its exact Shopify merchandise total.');
        }
        if (!String(props['_DCP Price Variant ID'] || '')
            || String(props['_DCP Price Variant ID'] || '') !== String(base.variant_id || base.id || '')) {
          errors.push('A Custom Die design does not match its exact-price Shopify variant.');
        }
        const isDcArtLine = Boolean(String(props['DC Art Library Design'] || '')
          || String(props['_DCP DC Art Catalog Version'] || '')
          || String(props['Text 1'] || '')
          || String(props['_SRD Designer Build'] || '') === 'v4.11-dc-personalize-draft');
        if (isDcArtLine) {
          let dcContract = null;
          let canvasObjects = null;
          let physicalCanvas = null;
          let dieContract = null;
          try { dcContract = JSON.parse(String(props._dcp_dc_art_production || '')); } catch (error) { dcContract = null; }
          try { canvasObjects = JSON.parse(String(props._dcp_canvas_objects || '')); } catch (error) { canvasObjects = null; }
          try { physicalCanvas = JSON.parse(String(props._dcp_physical_canvas || '')); } catch (error) { physicalCanvas = null; }
          try { dieContract = JSON.parse(String(props._dcp_die_production || '')); } catch (error) { dieContract = null; }
          if (!dcContract || dcContract.contractVersion !== 'srd-dc-art-plus-text-production-v1'
              || dcContract.catalogVersion !== 'srd-dc-art-catalog-v1') {
            errors.push('A personalized DC Art design is missing its trusted production contract.');
          } else {
            const contractText = Array.isArray(dcContract.textObjects) ? dcContract.textObjects : [];
            if (!dcContract.designId || dcContract.designId !== String(props['DC Art Library Design'] || '')
                || dcContract.catalogVersion !== String(props['_DCP DC Art Catalog Version'] || '')
                || dcContract.vinylColor !== String(props['DC Vinyl Color'] || '')
                || String(dcContract.artSizeInches) + ' in' !== String(props['DC Artwork Size'] || '')
                || contractText.length < 1
                || contractText.length !== cents(props['_DCP Text Object Count'])) {
              errors.push('A personalized DC Art design has inconsistent artwork, color, size, or text evidence.');
            }
          }
          if (!canvasObjects || !Array.isArray(canvasObjects.textObjects) || !canvasObjects.artwork
              || !physicalCanvas || !Number(physicalCanvas.width) || !Number(physicalCanvas.height)
              || !dieContract || !dieContract.eligibility || dieContract.eligibility.status !== 'ready') {
            errors.push('A personalized DC Art design cannot be restored in Edit Design.');
          }
          const productionReference = String(props['_DCP Production Reference ID'] || '');
          const proofReference = String(props['_DCP Final Proof Reference'] || '');
          const proofFile = String(props['_DCP Final Proof File'] || '');
          const hasTrustedProofFile = /^https:\/\/cdn\.shopify\.com\/s\/files\//.test(proofFile);
          if (!/^SRD-DCAPT-[A-Za-z0-9_-]+-\d+(?:\.\d+)?-[A-Za-z0-9_-]+$/.test(productionReference)
              || (!hasTrustedProofFile && proofReference !== productionReference)) {
            errors.push('A personalized DC Art design is missing its durable proof reference.');
          }
          if (!String(props._dcp_cart_edit_token || '')
              || String(props._dcp_cart_edit_token || '') !== String(props._dcp_pricing_group || '')
              || !String(props['_DCP Price Key'] || '')) {
            errors.push('A personalized DC Art design has invalid private pricing integrity data.');
          }
        }
        return;
      }
      const extraCount = cents(props['_DCP Additional Pieces']);
      const minimumQuantity = cents(props['_DCP Minimum Package Quantity']);
      const selectedQuantity = cents(props.Quantity);
      const unitPrice = cents(props['_DCP Additional Piece Price Cents']);
      const expectedBase = cents(props['_DCP Base Package Price Cents']);
      const expectedVariant = String(props['_DCP Surcharge Variant ID'] || '');
      const surchargeKey = String(props['_DCP Surcharge Key'] || '');
      const expectedFinished = cents(props['_DCP Finished Price Cents']);
      const baseTotal = lineTotal(base);

      if (Number(base.quantity || 0) !== 1) errors.push('A DCP package quantity was changed outside Edit Design.');
      if (!Number.isFinite(extraCount) || !Number.isFinite(minimumQuantity) ||
          !Number.isFinite(selectedQuantity) || selectedQuantity !== minimumQuantity + extraCount ||
          !Number.isFinite(unitPrice) || !Number.isFinite(expectedBase) ||
          !Number.isFinite(expectedFinished) || !surchargeKey || !Number.isFinite(baseTotal)) {
        errors.push('A DCP design has unresolved pricing integrity data.');
        return;
      }
      if (baseTotal !== expectedBase) errors.push('A DCP package price does not match Shopify.');

      if (extraCount === 0) {
        if (surcharges.length) errors.push('A minimum-quantity DCP design has an unexpected surcharge line.');
        if (baseTotal !== expectedFinished) errors.push('A minimum-quantity DCP Finished Price does not match Shopify.');
        return;
      }

      if (surcharges.length !== 1) {
        errors.push('An above-minimum DCP design does not contain exactly one surcharge line.');
        return;
      }

      const surcharge = surcharges[0];
      const surchargeProps = properties(surcharge);
      const surchargeTotal = lineTotal(surcharge);
      if (String(surcharge.variant_id || surcharge.id || '') !== expectedVariant) {
        errors.push('A DCP design contains the wrong surcharge variant.');
      }
      if (String(surchargeProps['_DCP Surcharge Key'] || '') !== surchargeKey) {
        errors.push('A DCP surcharge key does not match its configured design.');
      }
      if (Number(surcharge.quantity || 0) !== extraCount) {
        errors.push('A DCP surcharge quantity does not match Additional Pieces.');
      }
      if (cents(surcharge.final_price) !== unitPrice) {
        errors.push('A DCP surcharge unit price does not match the certified rate.');
      }
      if (surchargeTotal !== unitPrice * extraCount) {
        errors.push('A DCP surcharge line total is incorrect.');
      }
      if (baseTotal + surchargeTotal !== expectedFinished) {
        errors.push('A DCP Finished Price does not match its Shopify merchandise lines.');
      }
    });

    const allLinesTotal = items.reduce((sum, line) => sum + lineTotal(line), 0);
    if (!Number.isFinite(allLinesTotal) || allLinesTotal !== cents(cart.items_subtotal_price)) {
      errors.push('The Shopify cart merchandise subtotal does not reconcile with its lines.');
    }

    return { managed: true, valid: errors.length === 0, errors: [...new Set(errors)] };
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Shopify cart validation is temporarily unavailable.');
    return response.json();
  }

  function statusContainers() {
    return Array.from(document.querySelectorAll('[data-srd-dcp-cart-error]'));
  }

  function renderStatus(result) {
    const message = result.valid ? '' :
      'This DCP design cannot proceed to checkout. ' + result.errors.join(' ');
    statusContainers().forEach((container) => {
      if (container.textContent !== message) container.textContent = message;
      container.hidden = !message;
    });
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      if (result.managed && !result.valid) {
        button.setAttribute('aria-disabled', 'true');
        button.dataset.srdDcpIntegrityBlocked = 'true';
      } else {
        button.removeAttribute('aria-disabled');
        delete button.dataset.srdDcpIntegrityBlocked;
      }
    });
  }

  async function validateCurrentCart() {
    if (validationPromise) return validationPromise;
    validationPromise = fetchCart()
      .then((cart) => {
        const result = validateCart(cart);
        renderStatus(result);
        return { cart, result };
      })
      .catch((error) => {
        const result = { managed: true, valid: false, errors: [error.message] };
        renderStatus(result);
        return { cart: null, result };
      })
      .finally(() => {
        validationPromise = null;
      });
    return validationPromise;
  }

  async function removeDesign(group, button) {
    button.disabled = true;
    try {
      const cart = await fetchCart();
      const matching = cart.items.filter((line) =>
        String(properties(line)._dcp_pricing_group || '') === group
      );
      if (!matching.length) throw new Error('The DCP design could not be found in the cart.');
      const updates = {};
      matching.forEach((line) => { updates[line.key] = 0; });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Shopify did not remove the complete DCP design.');
      const updatedCart = await response.json();
      const remains = updatedCart.items.some((line) =>
        String(properties(line)._dcp_pricing_group || '') === group
      );
      if (remains) throw new Error('Removal verification failed. The complete DCP design is still in the cart.');
      window.location.reload();
    } catch (error) {
      renderStatus({ managed: true, valid: false, errors: [error.message] });
      button.disabled = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-srd-dcp-remove-group]');
    if (removeButton) {
      event.preventDefault();
      await removeDesign(String(removeButton.dataset.srdDcpRemoveGroup || ''), removeButton);
      return;
    }

    const checkout = event.target.closest('[name="checkout"]');
    if (!checkout || checkoutBypass) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const validation = await validateCurrentCart();
    if (!validation.result.valid) return;
    checkoutBypass = true;
    checkout.click();
    window.setTimeout(() => { checkoutBypass = false; }, 1000);
  }, true);

  document.addEventListener('submit', async (event) => {
    if (checkoutBypass || !event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const validation = await validateCurrentCart();
    if (!validation.result.valid) return;
    checkoutBypass = true;
    event.target.requestSubmit(event.submitter);
    window.setTimeout(() => { checkoutBypass = false; }, 1000);
  }, true);

  function scheduleValidation() {
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(validateCurrentCart, 120);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('cart-drawer, cart-items, [data-srd-dcp-base]')) return;
    validateCurrentCart();
    const cartRoot = document.querySelector('cart-drawer, cart-items');
    if (cartRoot) {
      new MutationObserver(scheduleValidation).observe(cartRoot, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleValidation);
    }
  });

  document.addEventListener('cart:updated', scheduleValidation);
})();
